"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Card } from "@/components/ui/card";
const blocks = [{
  title: "Torne Leve o Trabalho de Revestimentos Pesados",
  description: "Aplicar revestimentos espessos, pegajosos e oleosos é difícil. Métodos desatualizados e manuais podem complicar ainda mais a situação. Isto pode resultar em má qualidade, desperdício de materiais e maior rejeição. A limpeza também demora mais e as áreas de trabalho podem tornar-se inseguras. Pode tentar conter a sujidade, mas isso não resolve o problema real. Quer esteja a trabalhar com chocolate, caramelo, xaropes ou líquidos espessos, os nossos especialistas locais em pulverização estão aqui para ajudar. Utilizamos tecnologia de pulverização para garantir que os revestimentos são aplicados da forma correta — de forma rápida e precisa.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.09.png?v=hu34el8u3n9",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.09.png?v=s9be2pmv2j-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.09.png?v=hi1a3wp0qt-wvc-sizes",
  alt: "Aplicação de Óleo e Temperos em tambores rotativos"
}, {
  title: "Coloque Óleos e Agentes de Desmoldagem no Seu Lugar",
  description: "Demasiado pode acumular-se e comprometer a qualidade. Muito pouco e o produto não se solta. O que precisa é de um revestimento fino e uniforme — apenas o suficiente para cobrir o produto ou os pontos de contacto com o tabuleiro, moldes ou correias transportadoras. Isto permite-lhe utilizar menos e obter mais dos seus óleos e agentes de desmoldagem. Com produtos de diferentes formas e dimensões — e moldes e tabuleiros com cantos, fendas e zonas de difícil acesso — é mais fácil dizer do que fazer. Felizmente, nós fazemos o difícil todos os dias. Para além de poupar revestimentos, os nossos especialistas locais em pulverização ajudam-no a melhorar a qualidade, reduzir o desperdício, prolongar a vida útil do equipamento, proteger os trabalhadores e tornar a limpeza muito mais simples.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.14.png?v=tcnfe0ednn",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.14.png?v=sgi3keqlpn-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.14.png?v=rs7nc81li4q-wvc-sizes",
  alt: "Sistemas de pulverização e sopragem para controlo de processo na fritura"
}, {
  title: "Revestimento Consistente. Limpeza Mais Fácil. Menos Tempos de Parage",
  description: "Aplique apenas o que pretende e nada do que não pretende. Com os nossos manifolds e bicos, obtém um ângulo de pulverização e uma cobertura consistentes lote após lote. Isto significa maior qualidade e menos sujidade no equipamento e no espaço de trabalho. E, com opções de acesso e remoção fáceis e de libertação rápida, a limpeza e a substituição de bicos tornam-se mais rápidas e eficientes.\nO resultado? Menos tempos de paragem, equipamento de maior durabilidade e operações mais fluidas. E, como a Spraying Systems Co. é a sua fonte única para manifolds e bicos, pode evitar as dores de cabeça de gerir múltiplos fornecedores e continuar a obter o máximo desempenho em todas as situações.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.20.png?v=5ibex9ck003",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.20.png?v=jgd3dtxp16-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-06-as-16.11.20.png?v=u45u1j8o63-wvc-sizes",
  alt: "Sistema de lavagem automatizada para higienização de linhas de produção"
}];
export default function ProductShowcase() {
  const reduce = useReducedMotion();
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: reduce ? 0 : 16
    },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        delay: reduce ? 0 : i * 0.08,
        ease: [0.32, 0.72, 0, 1] as [number, number, number, number]
      }
    })
  };
  return <section data-section-id="31243" id="productshowcase" data-nav="dark" className="bg-background text-foreground font-default relative overflow-hidden py-32 md:py-44">
      <div aria-hidden="true" className="pointer-events-none absolute -top-40 right-[-10%] h-[520px] w-[520px] rounded-lg blur-[120px] opacity-40" style={{
      background: "hsl(215 90% 45% / 0.28)"
    }} />

      <div className="relative mx-auto w-full max-w-[1360px] px-5 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-end">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          amount: 0.3
        }} variants={fadeUp} custom={0} className="lg:col-span-7">
            <div className="text-xs font-medium uppercase mb-6" style={{
            letterSpacing: "0.22em",
            color: "hsl(215 90% 45%)"
          }}>
              Soluções
            </div>
            <h2 className="font-default font-normal" style={{
            fontSize: "clamp(2.25rem, 4.6vw, 4.25rem)",
            letterSpacing: "-0.03em",
            lineHeight: 1.02
          }}>Tecnologia de Pulverização para Snacks</h2>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          amount: 0.3
        }} variants={fadeUp} custom={1} className="lg:col-span-5 lg:text-right">
            <p className="max-w-[52ch] lg:ml-auto" style={{
            fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
            lineHeight: 1.5,
            color: "hsl(215 12% 40%)",
            letterSpacing: "-0.005em"
          }}>A aplicação de ingredientes, aromatizantes, revestimentos e agentes de desmoldagem é um desafio. E quanto mais espesso, pegajoso e viscoso for o material, maior é o desafio. A tecnologia de pulverização da Spraying Systems Co. pode ajudar a aplicar de forma precisa e eficiente os materiais de revestimento mais pesados e complexos — mesmo aqueles que possa ter considerado demasiado espessos para aplicação por pulverização. Garantimos um revestimento uniforme, eliminar o desperdício de ingredientes dispendiosos e otimizar a aplicação de agentes de desmoldagem e lubrificantes para melhorar a qualidade do produto e reduzir o desperdício.</p>
          </motion.div>
        </div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8">
          {blocks.map((block, i) => <motion.div key={block.title} data-index={i} initial="hidden" whileInView="visible" viewport={{
          once: true,
          amount: 0.2
        }} variants={fadeUp} custom={i} className="flex flex-col">
              <Card className="group relative flex flex-col h-full overflow-hidden rounded-3xl p-0 transition-all duration-300 hover:-translate-y-1 shadow-md" style={{
            background: "hsl(210 10% 92% / 0.4)",
            border: "1px solid hsl(210 10% 85%)",
            backdropFilter: "blur(24px) saturate(140%)",
            WebkitBackdropFilter: "blur(24px) saturate(140%)"
          }}>
                <div className="relative aspect-[16/10] w-full overflow-hidden bg-muted">
                  <img src={block.image} data-wvc-srcset={block.srcset} data-wvc-sizes={block.sizes} alt={block.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="flex flex-1 flex-col justify-between p-8">
                  <div>
                    <h3 className="font-default font-semibold text-foreground text-xl md:text-2xl" style={{
                  letterSpacing: "-0.02em",
                  lineHeight: 1.2
                }}>
                      {block.title}
                    </h3>
                    <p className="mt-4 text-muted-foreground text-base leading-relaxed">
                      {block.description}
                    </p>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}